import { render } from "./more-info-card.vue?vue&type=template&id=f1c68f46"
import script from "./more-info-card.vue?vue&type=script&lang=js"
export * from "./more-info-card.vue?vue&type=script&lang=js"

import "./more-info-card.vue?vue&type=style&index=0&id=f1c68f46&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__